import { Input } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEyeDropperHalf } from '@fortawesome/pro-solid-svg-icons/faEyeDropperHalf'
import { Wrapper } from './styled'

interface IProps {
  value: string
  onChange: (value: string) => void
}

export const ColorPicker = ({ value, onChange }: IProps) => {
  return (
    <Wrapper color={value}>
      <input
        type="color"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        id="color-picker"
      />
      <label htmlFor="color-picker">
        <div />
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          suffix={<FontAwesomeIcon icon={faEyeDropperHalf} />}
          size="large"
        />
      </label>
    </Wrapper>
  )
}
